import React, { useState } from "react";
import "./Login.css";
import { API_ENDPOINTS } from "../../config/api";
import { fetchBootstrap } from "../../api/bootstrap";

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const url = API_ENDPOINTS.LOGIN();            // <<--- PARENTHÈSES
      console.log("Login - URL utilisée:", url);    // doit afficher stericab-backend.onrender.com

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      // parse robuste (évite "Unexpected end of JSON input" sur 405/HTML)
      const ct = res.headers.get("content-type") || "";
      const payload = ct.includes("application/json") ? await res.json() : { message: await res.text() };

      if (!res.ok) {
        setError(payload.error || payload.message || `Erreur ${res.status}`);
        setLoading(false);
        return;
      }

      if (!payload?.token) {
        setError("Réponse serveur invalide (pas de token).");
        setLoading(false);
        return;
      }

      // Sauvegarde le token et l'userId
      try {
        localStorage.setItem("token", payload.token);
        localStorage.setItem("userId", payload.userId);
      } catch (e) {
        console.error('Failed to save auth data:', e);
        // Optionnel : fallback vers sessionStorage ou autre
      }

      // ★ PRÉCHAUFFAGE CACHE
      try {
        await fetchBootstrap(payload.userId, payload.token);
      } catch (e) {
        console.warn('Bootstrap a échoué, on continue quand même :', e?.message || e);
      }

      // Coupe le loader avant la navigation
      setLoading(false);
      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      console.error(err);
      setError("Impossible de se connecter au serveur");
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* LOADER OVERLAY */}
      {loading && (
        <div className="login-loading-overlay">
          <div className="login-spinner"><div className="login-spinner-inner" /></div>
          <div className="login-loading-text">Connexion…</div>
        </div>
      )}

      <div className="login-left">
        <div className="logo-box" aria-hidden="true">
          <svg width="40" height="40" viewBox="0 0 44 44" fill="none">
            <rect x="0" y="0" width="18" height="18" rx="4" fill="#5fa8ff" />
            <rect x="26" y="0" width="18" height="18" rx="4" fill="#657cff" />
            <rect x="0" y="26" width="18" height="18" rx="4" fill="#3ac0fc" />
            <rect x="13" y="13" width="18" height="18" rx="4" fill="#5fa8ff" />
            <rect x="26" y="26" width="18" height="18" rx="4" fill="#6bd5ff" />
            <rect x="19" y="19" width="6" height="6" rx="3" fill="#fff" />
          </svg>
        </div>

        <h1>Bienvenue sur<br />SteriPro</h1>
        <p className="subtitle">Connectez-vous pour accéder à votre espace stérilisation</p>
        {/* Redéploiement Vercel - commit cf5a3b2 */}

        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Mot de passe"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />

          <button type="submit" disabled={loading} aria-disabled={loading}>
            {loading ? "Connexion…" : "Se connecter"}
          </button>

          {error && <p className="error-msg">{error}</p>}

          <div className="login-links">
            <a href="#">Mot de passe oublié ?</a>
            <span> · </span>
            <a href="#">Cliquez ici</a>
          </div>
        </form>

        <button className="register-btn" disabled={loading}>Inscription</button>
      </div>

      <div className="login-right" aria-hidden="true">
        <img src={process.env.PUBLIC_URL + "/sterilisation.jpg"} alt="Autoclave" />
      </div>
    </div>
  );
}

export default Login;